import { render } from "./remove-zone.vue?vue&type=template&id=23ba4e4c"
import script from "./remove-zone.vue?vue&type=script&lang=js"
export * from "./remove-zone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__